import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { Spin, Form, Input, Button } from 'antd';

import { Config } from '../../public/js/config';
import $ from 'jquery';
import './login.css';
import Message from '../../component/message/message';
import trans from './translation';
import StatementModal from './statementModal';
import { Base } from '../../public/js/base';

import userLogin from '../../public/img/UserLogin.png';
import loginLogoImg from '../../public/img/loginLogo.png';
import logoImg from '../../public/img/logo.jpg';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import Captcha from 'react-captcha-code';
import zfzzjhImg from '../../public/img/zfzzjhImg.png';

export let searchCohortYear;

const Login = (props) => {

    let timer = useRef();
    const history = useHistory();
    const messageRef = useRef();
    const statementModalRef = useRef();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [isLoad, setIsLoad] = useState(false);
    const [flag, setFlag] = useState(true);
    const [userModel, setUserModel] = useState({});
    const [userInfoModel, setUserInfoModel] = useState({});
    const [resendTime, setResendTime] = useState("");
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [btnContent, setBtnContent] = useState('Send');
    const [isStatementModal, setIsStatementModal] = useState(false);
    const [code, setCode] = useState("");
    const captchaRef = useRef(null);
    const [shutdownFlag, setShutdownFlag] = useState(false);
    const [shutdownMessage, setShutdownMessage] = useState(false);

    useEffect(() => {
        searchResendTime();
        checkLogin();
        checkShutdownTime();
    }, []);

    searchCohortYear = () => {
        $.ajax({
            url: Config.apiServer + "partner/back/cohort/searchCohortYear",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    Config.cohort = data?.object
                } else {
                    console.log("error", data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
            }
        })
    }

    const checkLogin = () => {
        if (Base.isEmpty(Config.header.authorization)) {
            Config.header.authorization = localStorage.getItem(Config.tokenPrefix + 'AccessToken');
        }
        let token = localStorage.getItem(Config.tokenPrefix + 'RefreshToken');
        if (token) {
            $.ajax({
                url: Config.apiServer + "partner/login/checkToken",
                type: "POST",
                data: JSON.stringify(token),
                async: false,
                headers: Config.header,
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                success: (data) => {
                    if ("SUCCESS" === data.msg && data.object.userInfo.userType === 'PARTNER') {
                        Config.userInfo = data.object.userInfo;
                        Config.header.authorization = data.object.accessToken + '';
                        Config.sasToken = data.object.sasToken;
                        localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                        localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                        history.push('/partner');
                    } else {
                        localStorage.removeItem(Config.tokenPrefix + 'AccessToken');
                        localStorage.removeItem(Config.tokenPrefix + 'RefreshToken');
                    }
                },
                error: (jqXHR, textStatus, errorThrown) => {
                }
            });
        }
    }

    const onFinish = (values) => {
        if(shutdownFlag) {
            errFrameShow('error', shutdownMessage);
            return;
        }
        messageShowHandler();
        setLoading(true);
        fetch(Config.apiServer + "partner/login/checkUser", {
            method: 'POST',
            body: JSON.stringify(values),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setUserModel({ ...values, ...(data?.object ?? {}) })
                setFlag(false)
                sendEmail(values);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const ajaxLogin = (smsCode) => {
        messageShowHandler();
        let model = {};
        model.pwd = userModel.pwd;
        model.userCode = userModel.userCode;
        model.smsCode = smsCode;
        setLoading(true);
        fetch(Config.apiServer + "partner/login/ajaxLogin", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object.userInfo
                Config.userInfo = model;
                Config.header.authorization = data.object.accessToken + '';
                Config.sasToken = data.object.sasToken;
                localStorage.setItem(Config.tokenPrefix + 'AccessToken', data.object.accessToken);
                localStorage.setItem(Config.tokenPrefix + 'RefreshToken', data.object.refreshToken);
                searchCohortYear();
                history.push('/partner');
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const checkSmsCode = (values) => {
        messageShowHandler();
        if (code !== values.code) {
            errFrameShow("error", "Invalid captcha.");
            captchaRef.current.refresh();
            return
        }
        values.userCode = userModel.userCode
        values.pwd = userModel.pwd
        setLoading(true);
        fetch(Config.apiServer + "partner/login/checkSmsCode", {
            method: 'POST',
            body: JSON.stringify(values),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data.object ?? {}
                setUserInfoModel(model);
                if (userModel.statementInd === 'N') {
                    setIsStatementModal(true)
                } else {
                    ajaxLogin(model.smsCode)
                }
            } else {
                errFrameShow("error", data.msg);
                captchaRef.current.refresh();
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    const sendEmail = (values) => {
        messageShowHandler();
        let model = userModel
        if (values) {
            model = values
        }
        setLoading(true);
        fetch(Config.apiServer + "partner/login/sendCode", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!values) {
                    errFrameShow("success", 'Verification Code sent successfully.');
                }
                countDownFunc(resendTime);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const searchResendTime = () => {
        messageShowHandler();
        setLoading(true);
        fetch(Config.apiServer + "partner/login/searchResendTime", {
            method: 'POST',
            body: JSON.stringify(userModel),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                let model = data?.object
                setResendTime(model.resendTime);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setLoading(false));
    }

    const countDownFunc = (time) => {
        setBtnDisabled(true);
        setBtnContent(`Resend ${time}s`);
        timer.current = setInterval(() => {
            time--;
            setBtnContent(`Resend ${time}s`);
            if (time === 0) {
                setBtnDisabled(false);
                setBtnContent('Send');
                clearInterval(timer.current);
            }
        }, 1000);
    }

    const cancel = () => {
        messageShowHandler();
        setFlag(true);
        clearInterval(timer.current)
    }

    const confirmStatement = () => {
        if (isLoad) {
            return
        }
        let model = userModel;
        model.smsCode = userInfoModel?.smsCode;
        setIsLoad(true);
        fetch(Config.apiServer + "partner/login/confirmStatement", {
            method: 'POST',
            body: JSON.stringify(model),
            headers: Config.header,
            mode: 'cors',
            cache: 'default'
        }).then(res => res.json()).then((data) => {
            if ("SUCCESS" === data.msg) {
                setIsStatementModal(false)
                ajaxLogin(model.smsCode)
            } else {
                setIsStatementModal(false)
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const closeStatementModal = (flag) => {
        if (flag) {
            confirmStatement()
        } else {
            setIsStatementModal(false)
        }
    }

    const handleChange = (code) => {
        setCode(code);
    }

    const handleClick = () => {
        captchaRef.current.refresh();
    }

    const checkShutdownTime = () => {
        $.ajax({
            url: Config.apiServer + "partner/login/checkShutdownTime",
            type: "POST",
            async: false,
            headers: Config.header,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: (data) => {
                if ("SUCCESS" === data.msg) {
                    setShutdownFlag(false);
                } else {
                    setShutdownFlag(true);
                    setShutdownMessage(data.msg);
                }
            },
            error: (jqXHR, textStatus, errorThrown) => {
                setShutdownFlag(true);
                setShutdownMessage('WIL Platform is currently under maintenance.');
            }
        })
    }

    return (
        <div className='login'>
            {isStatementModal && <StatementModal onClose={closeStatementModal} />}
            <div className='logoBox'>
                <img src={loginLogoImg} />
            </div>
            <div className='line'></div>
            <div className='loginBackground'>
                <div className='loginMessageBox'>
                    <Message ref={messageRef} />
                </div>
                {shutdownFlag && <div className='tipBox tipErrorBox'>
                    {shutdownMessage}
                </div>}
                {/* <div className='tipBox'>
                    <div>This is a User Testing environment using simulated data, which means the information provided is not real.</div>
                    <div>Please refrain from sharing any real personal data during testing.</div>
                </div> */}
                {flag ?
                    <div className='loginBox'>
                        <div className='loginLogoBox'>
                            <img src={logoImg} />
                        </div>
                        <div className="textBox">
                            <Spin spinning={loading}>
                                <Form form={form} onFinish={onFinish}>
                                    <div className='title'>{trans.title[Config.backLang]}</div>
                                    <Form.Item
                                        name="userCode"
                                    >
                                        <Input maxLength={100} style={{ backgroundColor: '#FFFFFF' }} className="loginInput" placeholder={trans.userName[Config.backLang]} />
                                    </Form.Item>
                                    <Form.Item
                                        name="pwd"
                                    >
                                        <Input type="password" className="loginInput" placeholder={trans.password[Config.backLang]} maxLength={100} />
                                    </Form.Item>
                                    <Button icon={<img src={userLogin} />} type="primary" htmlType="submit" className="loginFormButton" disabled={loading}>{trans.login[Config.backLang]}</Button>
                                </Form>
                                <div className="botButtonDiv" style={{ marginTop: '20px' }}>
                                    <div className='sysUpdate' onClick={() => history.push("/indexAbout")}>About</div>
                                    <div className='sysUpdate' onClick={() => history.push("/forgotUserID")}>Forgot User ID</div>
                                    <div className='sysUpdate' onClick={() => history.push("/forgotPassword")}>Forgot Password</div>
                                    <div className='sysUpdate' onClick={() => history.push("/help")}>Help</div>
                                </div>
                            </Spin>
                        </div>
                    </div>
                    :
                    <div className='loginBox'>
                        <Spin spinning={loading}>
                            <Form form={form} onFinish={checkSmsCode}>
                                <div className='title'>Please enter the verification code send to your email address</div>
                                <Form.Item
                                    name="smsCode"
                                >
                                    <div className='loginFlexBox'>
                                        <span>Code</span>
                                        <Input maxLength={100} style={{ backgroundColor: '#FFFFFF' }} className="loginInput" placeholder="Code" />
                                        <Button className="sysBtn loginSendButton" onClick={() => sendEmail()} disabled={btnDisabled}>{btnContent}</Button>
                                    </div>
                                </Form.Item>
                                <Form.Item
                                    name="code"
                                >
                                    <div className='loginFlexBox'>
                                        <Input maxLength={100} style={{ backgroundColor: '#FFFFFF' }} className="loginInput" placeholder="Captcha" />
                                        <Captcha ref={captchaRef} onChange={handleChange} onClick={handleClick} />
                                    </div>
                                </Form.Item>

                                <div className='confirmButtonRow'>
                                    <Button className="sysBtn btnBlue loginSendButton" type="primary" htmlType="submit" icon={<CheckOutlined />} disabled={loading}>Confirm</Button>
                                    <Button className="sysBtn loginSendButton" onClick={() => cancel()} icon={<CloseOutlined />}>Cancel</Button>
                                </div>
                            </Form>
                        </Spin>
                    </div>
                }
                <div className='tipMaxBox'>
                    The THEi WIL Digital Platform is funded by the Quality Enhancement Support Scheme (QESS) - Formation and Development of a Work Integrated Learning Hub for Diverse Programmes of THEi (Project no.: IA03/QESS/2022).
                    Any opinions, findings, conclusions or recommendations expressed in this material/event (or by members of the project team) do not reflect the views of the Government of the Hong Kong Special Administrative Region, the Education Bureau, any member in the Committee on Self-financing Postsecondary Education (CSPE) and its Sub-committee on Support Measures, and the Secretariat of the CSPE and its Sub-committee on Support Measures.
                </div>
                <div className='loginLogoBox'>
                    <img src={zfzzjhImg} />
                </div>
            </div>
        </div>
    )
}

export default Login;